<template>
	<div class="departmentList">
      <v-flex xs3 storeListSearch>
        <v-text-field append-icon="search" label="Search" solo single-line v-model="search"></v-text-field><br />
      </v-flex>
		<v-data-table loading="true" :headers="headers" :items="branchList" ref="sortableTable" :search="search" hide-actions disable-initial-sort class="elevation-1">
			<template slot="items" slot-scope="props">
				<tr class="sortableRow" id="rows">
					<td width="30%">{{ props.item.name }}</td>
					<td width="20%" >{{ props.item.code }}</td>
					<td width="15%"  v-html="fncGetPricelist(props.item)"></td>
					<td width="15%" >{{ props.item.created }}</td>
					<td width="10%" v-if="objAuthorize.privileges.indexOf('BRANCH_MODULE') !== -1" ><a @click.prevent="fncShowEdit(props.item)"><i class="material-icons">edit</i></a></td>
					<td width="10%" v-if="objAuthorize.privileges.indexOf('BRANCH_MODULE') !== -1" ><a @click.prevent="fncBranchDelete(props.item)"><i class="material-icons">delete</i></a></td>
				</tr>
			</template>
		</v-data-table>
	</div>
</template>

<script>

  import { mapGetters } from 'vuex';

  export default {
	name: 'RoleList',
	intRoleEdit: 0,
    data () {
		return {
			search: '',
            headers: [
              { text: 'Name', value: 'name', width: '30%' },
              { text: 'Branch Code', value: 'description', width: '20%' },
              { text: 'Pricelist', value: 'description', width: '15%' },
              { text: 'Created On', value: 'created_on', width: '15%' },
              { text: 'Edit', value: 'edit', width: '10%' },
              { text: 'Delete', value: 'delete', width: '10%' }
            ]
		}
	},
	methods: {
    fncGetPricelist( item ) {

      if( item.branch_department_pricelists != '' && item.branch_department_pricelists != 'null' && item.branch_department_pricelists != null ) {

        var finalPricelists = '';

        var pricelistRefs = [];
        for( var p in this.pricelistList ) {
          pricelistRefs[this.pricelistList[p].pl_id] = this.pricelistList[p].pl_name;
        }

        var departmentPricelists = JSON.parse( item.branch_department_pricelists );
        if( departmentPricelists.length > 0 ) {
          for( var d in departmentPricelists ) {
            finalPricelists += pricelistRefs[departmentPricelists[d].pricelists] + '<br />';
          }
        }

        return finalPricelists;

      }
      return '<strong style="color: red;">Not Set</strong>';

      /*for( var p in this.pricelistList ) {
        if( plId == String(this.pricelistList[p].pl_id) ) {
          return this.pricelistList[p].pl_name;
        }
      }
      return '<strong style="color: red;">Not Set</strong>';*/
    },
      fncShowEdit(branch) {
        this.$store.dispatch(
          {
            type: 'fncPopulateBranchesEdit',
            branchId: branch.branchId,
            regions: this.userRegions,
            name: branch.name
          });
		},
    fncBranchDelete(branch) {
			if( branch.linked == true ) {
				alert('The store can not be deleted as it has users linked to it');
			} else {
				var confirmDelete = confirm('Are you sure you would like to remove ' + branch.name + '?');
				if (confirmDelete === true) {
					this.$store.dispatch({
						type: 'fncBranchDelete',
						branchId: branch.branchId
					});
				}
			}
		},
	},
	computed: {
		...mapGetters([
			'userRoles',
			'objRoleEdit',
			'objAuthorize',
      'branchList',
      'userRegions',
      'pricelistList'
		])
	},
	beforeMount() {
      this.$store.dispatch('fncPopulateBranches');
      this.$store.dispatch('fncPopulateUserRegions');
      this.$store.dispatch('fncPopulatePricelistList');
      this.$store.dispatch('fncPopulateDepartments');

	  this.$store.dispatch({
        type: 'fncPopulateUsers',
        context: 1,
        notification: 1
      });
	},
	mounted() {

	  var oldThis = this;
		if( this.branchList.length > 0 && this.branchList[0].id == '' ) {
			this.branchList.shift();
		}

		/*setTimeout(function(){
      oldThis.$store.dispatch('fncPopulateBranches');
    }, 1000)*/
	} ,
	watch: {
		branchList() {
			if( this.branchList[0].id = '' ) {
				this.branchList.shift();
			}
		}
	}
}
</script>

<style scoped>
	@import '../shared/assets/css/shared.css'
</style>
